import {QueryClientProvider} from '@tanstack/react-query';
import React from 'react';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {Provider} from 'react-redux';

import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import Translation from '@/components/Translation/Translation';
import ExternalWalletProvider from '@/modules/ExternalWallet/ExternalWalletProvider/ExternalWalletProvider';
import EmbedToastProvider from '@/modules/Toasts/EmbedToastProvider';
import EmbedNavigation from '@/navigation/EmbedNavigation/EmbedNavigation';
import {queryClient, setupReactQuery} from '@/services/reactQuery/embed';
import EmbedThemeProvider from '@/theme/EmbedThemeProvider';

setupReactQuery();

const EmbedApp = () => {
  return (
    <SafeAreaProvider>
      <ErrorBoundary>
        <Translation>
          <QueryClientProvider client={queryClient}>
            <EmbedThemeProvider>
              <EmbedToastProvider>
                <ExternalWalletProvider>
                  <EmbedNavigation />
                </ExternalWalletProvider>
              </EmbedToastProvider>
            </EmbedThemeProvider>
          </QueryClientProvider>
        </Translation>
      </ErrorBoundary>
    </SafeAreaProvider>
  );
};

export default EmbedApp;
